<template>
  <div>
    <div class="d-flex justify-space-between pa-5 pb-0 ga-5">
      <div>
        <h4 class="font-size-20">{{ title }}</h4>
        <div v-if="subtitle" class="text-disabled font-size-15">
          {{ subtitle }}
        </div>
      </div>
      <v-btn
        class="ma-0"
        icon
        variant="plain"
        density="comfortable"
        @click="closeDialog">
        <v-icon color="var(--grey)">mdi-close-circle-outline</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'DialogToolbar',
  props: {
    title: { type: String },
    subtitle: { type: String },
    closeDialog: { type: Function },
  },
}
</script>

<style scoped lang="scss"></style>
